import clsx from "clsx";

const Input = ({
  label,
  name,
  register,
  validation,
  error,
  description,
  ...other
}) => {
  return (
    <div
      className={clsx(
        "form-group",
        !!validation?.required && "required",
        error && "invalid"
      )}
    >
      <label htmlFor={`${name}_input`} className="form-label">
        {label}
      </label>

      <input
        id={`${name}_input`}
        className={clsx("form-control", error && "is-invalid")}
        placeholder={label}
        {...register(name, validation)}
        {...other}
      />

      {error && <div className="invalid-feedback">{error.message}</div>}

      {description && !error && (
        <div className="helper-feedback">{description}</div>
      )}
    </div>
  );
};

export default Input;
